import { personInitials } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';
import { useVoice } from '@/platform/voice/use-voice';

/** Decorative circle for a colleague. The directory DTO has no given name, so initials come from `displayName`. */
export function ColleaguePortrait({
  displayName,
  profilePhotoUrl,
  className,
}: {
  displayName: string;
  profilePhotoUrl: string | null;
  className?: string;
}) {
  const voice = useVoice();
  if (profilePhotoUrl) {
    return (
      <img
        src={profilePhotoUrl}
        alt=""
        className={cn('size-12 shrink-0 rounded-full object-cover', className)}
      />
    );
  }

  return (
    <span
      className={cn(
        'grid size-12 shrink-0 place-items-center rounded-full bg-brand-navy-soft text-sm font-semibold text-brand-navy',
        className,
      )}
      aria-hidden
    >
      {personInitials({ displayName }, voice)}
    </span>
  );
}
